<template>
  <v-container>
    <h1>Update Poi Content Tags</h1>

    <progress-component script="UpdatePoiContentTags"></progress-component>
  </v-container>
</template>

<script>

import ProgressComponent from '../components/ProgressComponent.vue';

export default {
  name: 'UpdatePoiContentTags',
  components: { ProgressComponent },
};
</script>
